import DesempeñoInstitucional from '../domain/DesempeñoInstitucional'
import DesempeñoInstitucionalDto from '../domain/DesempeñoInstitucionalDto'

class CreateDesempeñoInstitucional {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(evaluacionDesempenioAcademico, idPersonal) {
    const catalogoReactivos = await this.#repository.getEvaluationItems()
    const dto = DesempeñoInstitucionalDto.create(evaluacionDesempenioAcademico, catalogoReactivos)
    const { data } = await this.#repository.create(dto, idPersonal)

    return data[0].ID
  }
}

export default CreateDesempeñoInstitucional
